import {
  createFilterFormStore,
  usePersistedFilterFormik,
} from "../../../util/usePersistedFilterFormik";
import { useEffect } from "react";
import { convertToFilter, makeObservable } from "../../../util";
import { createSearchResultNavigationStore } from "../../../util/searchResultNavigation";

// observable store
const jobFilterStore = makeObservable({});
const jobNavigationStore = createSearchResultNavigationStore(jobFilterStore);

const toJobFilter = values =>
  convertToFilter({
    values,
    filterKeys: ["tab"],
    skipKeys: ["limit", "offset"],
  });

const filterFormStore = createFilterFormStore(
  "jobs",
  jobFilterStore,
  jobNavigationStore,
  { toFilter: toJobFilter },
);

const useJobFilters = () => {
  const formik = usePersistedFilterFormik(
    {
      initialValues: {
        limit: 50,
        offset: 0,
        tab: "instance",
        sort1: { operator: "ASC" },
        sort2: { operator: "ASC" },
        sort3: { operator: "ASC" },
        pickupId: { operator: "in" },
      },
    },
    filterFormStore,
  );

  useEffect(() => {
    jobFilterStore.set(toJobFilter(formik.values));
  }, [formik.values]);

  return {
    formik,
  };
};

export { jobFilterStore, jobNavigationStore, useJobFilters };
